import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Space
} from "antd";
import TableSearchBar from "./tempComponents/searchBar";
import TableWithLoadingWrapper from "../../../components/generic/dataGrid";
import ClosedAccountsRowDropdown from "./tempComponents/closedAccounts";
import GenericTagChips from "../../../components/specific/customTags/genericTagChips";
import HeaderBox from "../../../components/generic/arpariBoxes/headerBox";
import Stack from "@mui/material/Stack";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import ExportClosedAccountModal from "./tempComponents/connectedAccounts/tableDropdown/ExportClosedAccountModal";

const ClosedAccounts = (props) => {
    const [closedAccounts, setClosedAccounts] = useState(props.closedAccounts);
    const [showAccounts, setShowAccounts] = useState([]);
    const [csvModalVisible, setCsvModalVisible] = useState(false);

    useEffect(() => {
        const accounts = props.closedAccounts.map((account) => {
            return {
                ...account,
                key: account.id
            }
        });

        setClosedAccounts(accounts)
        setShowAccounts(accounts)

    }, [props.closedAccounts]);


    const columns = [
        {
            field: 'bank_name',
            headerName: 'Institution',
            flex: 1.5,
            valueGetter: (_, params) => {
                return params?.account?.bank?.name;
            },
            renderCell: (params) => (
                <div style={{ width: '100%' }}>
                    {params?.row?.account?.bank?.name}
                </div>
            ),
        },
        {
            field: 'description',
            headerName: 'Account',
            flex: 1.5,
            valueGetter: (_, params) => {
                return params?.account?.account_description;
            },
            renderCell: (params) => {
                const { row } = params;
                const last4 = row.account.account_number_last_4;
                const isValidLast4 = last4 !== undefined && last4.length > 3 && last4.length < 7;
                return (
                    <>
                        {row?.account?.account_description}{" "}
                        {isValidLast4 ? <>....{last4}</> : undefined}
                    </>
                );
            },
        },
        {
            field: 'placement',
            headerName: 'Placement',
            flex: 1.5,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <GenericTagChips
                        genericTags={row.generic_tags}
                        purpose={row.purpose}
                        bank={row.account?.bank?.name}
                        beneficiary={row?.beneficiary?.name} />
                );
            },
        },
        {
            field: 'actions',
            headerName: '',
            flex: 0.1,
            align: 'right',
            renderCell: (params) => (
                <ClosedAccountsRowDropdown
                    record={params.row}
                    setClosedAccounts={props.setClosedAccounts}
                    setConnectedAccounts={props.setConnectedAccounts}
                />
            ),
        },
    ];


    return (
        <Stack direction="column" spacing={1}>
            <Grid container alignItems="flex-end">
                <Grid item xs={6}>
                    <TableSearchBar
                        originalTableData={closedAccounts}
                        updateTableState={setShowAccounts}
                        isLoading={props.loadingConnectedAccountsSlow}
                        searchKeys={[["account", "bank", "name"], ["description"], ["beneficiary", "name"], ["portfolio"], ["property"]]}
                    />
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', justifyItems: 'center', gap: '8px' }}>
                    <Button
                        variant="contained"
                        disabled={(!showAccounts || showAccounts.length === 0)}
                        onClick={(!showAccounts || showAccounts.length === 0) ? undefined : () => setCsvModalVisible(true)}
                        sx={{ fontSize: '12px', boxShadow: 'none' }}
                    >
                        Export Data
                    </Button>
                    <ExportClosedAccountModal
                        tableData={showAccounts}
                        exportModalVisible={csvModalVisible}
                        handleCancelModal={() => setCsvModalVisible(false)}
                    />
                </Grid>
            </Grid>

            <Row>
                <TableWithLoadingWrapper
                    columns={columns}
                    optInRowHeightAuto={true}
                    dataSource={showAccounts}
                    loading={props.loadingClosedAccounts}
                />
            </Row>
        </Stack>
    );
};

export default ClosedAccounts;